import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import OptionsSelector from '@panel/commons/lib/DropDown/OptionSelector';
import { BulkActionIcon, BulkActionIconContainer, BulkActionContainer, BulkActionText } from '../styles';

const MoreActionsButton = ({ actions }) => {
  const { t } = useTranslation();
  const positionRef = useRef(null);
  const [showOptionSelector, setOptionSelector] = useState(false);

  const handleOutsideClick = onElement => {
    if (onElement) setOptionSelector(false);
  };

  // Si no hay acciones adicionales no se renderiza el botón:
  if (actions.length === 0) return null;

  return (
    <BulkActionContainer
      position='relative'
      onClick={e => {
        e.stopPropagation();
        setOptionSelector(!showOptionSelector);
      }}
    >
      <BulkActionIconContainer>
        <BulkActionIcon action='moreActions' width='26px' height='26px' />
      </BulkActionIconContainer>
      <BulkActionText>{t('panel.bar.select.actions.moreActions')}</BulkActionText>

      {/* Renderiza las acciones adicionales dentro del OptionSelector */}
      {showOptionSelector && (
        <OptionsSelector
          isOpen={showOptionSelector}
          elementRef={positionRef}
          handleOutsideClick={handleOutsideClick}
          width='182px'
          topDown='49px'
          left='0px'
          padding='6px 0'
          hasSetUnmountComponent
        >
          {actions.map((action, index) => (
            <ActionsContainer key={`${index + 1}`}>{action.component}</ActionsContainer>
          ))}
        </OptionsSelector>
      )}
    </BulkActionContainer>
  );
};

export default MoreActionsButton;

const ActionsContainer = styled.div`
  .insideSelector {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 8px;
    margin: 8px 8px 8px 16px;
  }
`;
